// src/components/RequireProfileAccess.jsx
import React from "react";
import { Navigate, useParams } from "react-router-dom";

export default function RequireProfileAccess({ children }) {
  const { id } = useParams();

  let me = null;
  try {
    me = JSON.parse(localStorage.getItem("user") || "null");
  } catch {
    me = null;
  }

  if (!me) return <Navigate to="/" replace />;

  const myId = String(me.id || "");
  const myRole = String(me.role || "").toLowerCase();

  // ✅ Candidates can only access their own profile route
  if (myRole === "candidate" && String(id) !== myId) {
    return <Navigate to="/overview" replace />;
  }

  return children;
}
